// extracted by mini-css-extract-plugin
export default {"permit":"permit--zhmS5","input":"input--Kzs90","button":"button--Z9s4O","locked":"locked--gsfu2","approved":"approved--NMu2y"};